import React,{useState,useEffect} from "react";
import dwnld from "../../assets/svg/dwnld.svg";
import print from "../../assets/svg/print.svg";
import date from "../../assets/svg/date.svg";
import { Link ,Outlet} from "react-router-dom";
import { getLiveMonitorApi } from "./dashboard-api";

const Dashboard = () => {
  const [activeBtn, setActiveBtn] = useState("default");

 

  return (
    <div className="content_container">
      {/* <div className="dash_head ">
        <div className="dash_head_left ">
          <div className="head_left_btns d-flex gap-2">
            <Link to="default">
              <button
              type="button"
              className="head_left_btn"
              style={{ backgroundColor: activeBtn === "default" ? "#D35258" :" #FFFFFF",
                       color:activeBtn === "default" ? "#FFFFFF":"#172B4D" }}
                       onClick={() => setActiveBtn("default")}
            >
              Default
            </button>
            </Link>
            <Link to="futuristic">
             <button type="button" className="head_left_btn"  style={{ backgroundColor: activeBtn === "futuristic" ? "#D35258" :" #FFFFFF",
                       color:activeBtn === "futuristic" ? "#FFFFFF":"#172B4D" }}
                       onClick={() => setActiveBtn("futuristic")}>
              Futuristic
            </button></Link>
          </div>
          <div className="head_left_text">
            <div
              style={{
                backgroundColor: "#D35258",
                width: "3px",
                height: "13px",
              }}
            ></div>
            From the date of{" "}
            <span style={{ color: "#D35258", fontWeight: "500" }}>
              {" "}
              23 Feb, 2024 - 29 Feb, 2024
            </span>{" "}
          </div>
        </div>
        <div className="dash_hed_right  d-flex flex-wrap gap-3">
          <button type="button" className="head_right_btn">
            <img src={dwnld} alt="dwnld" />
            <span>Download report</span>
          </button>
          <button type="button" className="head_right_btn">
            <img src={print} alt="print" />
            <span>print report</span>
          </button>
          <button type="button" className="head_right_btn">
            <img src={date} alt="date" />
            <span>Show by date</span>
          </button>
        </div>
      </div> */}
      <div className="content-section">
        <Outlet />
      </div>
      
    </div>
  );
};

export default Dashboard;
